import React from "react";
import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "../components/ui/sheet";
import { Button } from "../components/ui/button";
import { Menu, Home, Settings, LayoutDashboard, Moon, Sun, HeartHandshake, NotebookPen, Share2, MessagesSquare } from "lucide-react";
import { isDiaryAvailable } from "../lib/availability";
import { FORUM_ENABLED } from "../lib/features";
import { useTheme } from "next-themes";

export default function MobileNav() {
  const nav = useNavigate();
  const [open, setOpen] = React.useState(false);
  const { theme, setTheme, resolvedTheme } = useTheme();

  const go = (to) => {
    setOpen(false);
    nav(to);
  };

  const isDark = theme === "dark" || (theme === "system" && resolvedTheme === "dark");
  const toggleTheme = () => setTheme(isDark ? "light" : "dark");
  const showDiary = isDiaryAvailable();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button data-tour-id="navbar-menu" variant="outline" size="icon" className="md:hidden" aria-label="Open menu">
          <Menu className="h-4 w-4" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[88vw] p-0">
        <SheetHeader className="px-4 py-3 border-b">
          <SheetTitle className="text-left">Menu</SheetTitle>
        </SheetHeader>
        <div className="p-3 grid gap-2">
          <Button variant="ghost" className="justify-start" onClick={() => go("/")}> <Home className="mr-2 h-4 w-4" /> Home</Button>
          <Button data-testid="mobile-tracker" variant="ghost" className="justify-start" onClick={() => go("/tracker")}><LayoutDashboard className="mr-2 h-4 w-4" /> Tracker</Button>
          <Button variant="ghost" className="justify-start" onClick={() => go("/sponsors")}><HeartHandshake className="mr-2 h-4 w-4" /> Our Sponsors</Button>
          {FORUM_ENABLED && <Button variant="ghost" className="justify-start" onClick={() => go("/forum")} data-testid="mobile-forum-button"><MessagesSquare className="mr-2 h-4 w-4" /> Forum</Button>}
          <Button variant="ghost" className="justify-start" onClick={() => go("/settings")}><Settings className="mr-2 h-4 w-4" /> Settings</Button>
          <Button variant="ghost" className="justify-start" onClick={() => go("/refer")}><Share2 className="mr-2 h-4 w-4" /> Refer Others</Button>
          {showDiary && <Button variant="ghost" className="justify-start" onClick={() => go("/diary")}><NotebookPen className="mr-2 h-4 w-4" /> Diary</Button>}
          <Button data-tour-id="nav-theme" variant="ghost" className="justify-start" onClick={toggleTheme} aria-label="Toggle theme">
            {isDark ? <Sun className="mr-2 h-4 w-4" /> : <Moon className="mr-2 h-4 w-4" />} Dark / Light Mode
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}